import { render, staticRenderFns } from "./CountryInfo.vue?vue&type=template&id=2c5205f8&"
import script from "./CountryInfo.vue?vue&type=script&lang=ts&"
export * from "./CountryInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CountryInfo.vue?vue&type=style&index=0&id=2c5205f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports